import axios from "axios";
import React, { useState, useEffect } from "react";

import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { FaFileExcel, FaFilePdf } from "react-icons/fa";

const TaxReport = ({clientData}) => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [reportType, setReportType] = useState("sale");

  const [saleTaxData, setSaleTaxData] = useState([]);
  const [purchaseTaxData, setPurchaseTaxData] = useState([]);

const fetchPurchase = async () => {
  try {
    const res = await axios.get(
      `https://api.dectwinbilling.com/fetch-purchase-bill-report/${clientData.id}`,
      {
        params: {
          fromDate: fromDate || undefined,
          toDate: toDate || undefined,
        },
      }
    );

    return res.data || [];

  } catch (error) {
    console.log("Purchase Error:", error);
    return [];
  }
};

const fetchPurchaseReturn = async () => {
  try {
    const res = await axios.get(
      `https://api.dectwinbilling.com/fetch-purchase-return-bill-report/${clientData.id}`,
      {
        params: {
          fromDate: fromDate || undefined,
          toDate: toDate || undefined,
        },
      }
    );

  

    return res.data || [];

  } catch (error) {
    console.log("Purchase Return Error:", error);
    return [];
  }
};


const fetchSaleHistory = async () => {
  try {
    const res = await axios.get(
      `https://api.dectwinbilling.com/fetch-sale-history-report/${clientData.id}`,
      {
        params: {
          fromDate: fromDate || undefined,
          toDate: toDate || undefined,
        },
      }
    );

   

    return res.data || [];

  } catch (error) {
    console.log("Sale History Error:", error);
    return [];
  }
};


const fetchSaleReturn = async () => {
  try {
    const res = await axios.get(
      `https://api.dectwinbilling.com/fetch-sales-return-bill-report/${clientData.id}`,
      {
        params: {
          fromDate: fromDate || undefined,
          toDate: toDate || undefined,
        },
      }
    );

    return res.data || [];

  } catch (error) {
    console.log("Sale Return Error:", error);
    return [];
  }
};


      const formatTaxData = (data, type) => {
  return data.map((item) => {

    let taxableAmount = 0;

    // Try to calculate taxable amount from tax values
    const igst = Number(item.igst) || 0;
    const cgst = Number(item.cgst) || 0;
    const sgst = Number(item.sgst) || 0;
    const taxAmount = Number(item.totalTax) || 0;

    /*
      If totalTax exists, use payable - tax as the
      basic taxable amount.

      Example:
      payable = 160.80
      tax = 4.80
      taxable = 156.00
    */
    if (item.payable !== undefined && taxAmount > 0) {
      taxableAmount =
        Number(item.payable || 0) - taxAmount;
    } else {
      taxableAmount =
        Number(item.payable || 0);
    }

    return {
      id: item.id,

      dateTime: item.date,

      particulars: item.name || "Cash",

      partyGstin: item.gstin || "-",

      vchType:
        type === "sale"
          ? "Sale"
          : type === "saleReturn"
          ? "Sale Return"
          : type === "purchase"
          ? "Purchase"
          : "Purchase Return",

      vchNo: item.invoiceNo,

      taxableAmount: taxableAmount,

      igst: igst,

      cgst: cgst,

      sgst: sgst,

      cess: Number(item.cess) || 0,

      taxAmount: taxAmount,

      billAmount: Number(item.payable) || 0,
    };
  });
};

const loadTaxReport = async () => {
  try {
    const [
      saleData,
      saleReturnData,
      purchaseData,
      purchaseReturnData,
    ] = await Promise.all([
      fetchSaleHistory(),
      fetchSaleReturn(),
      fetchPurchase(),
      fetchPurchaseReturn(),
    ]);

    // SALE + SALE RETURN
    const formattedSale = formatTaxData(
      saleData,
      "sale"
    );

    const formattedSaleReturn = formatTaxData(
      saleReturnData,
      "saleReturn"
    );

    setSaleTaxData([
      ...formattedSale,
      ...formattedSaleReturn,
    ]);

    // PURCHASE + PURCHASE RETURN
    const formattedPurchase = formatTaxData(
      purchaseData,
      "purchase"
    );

    const formattedPurchaseReturn = formatTaxData(
      purchaseReturnData,
      "purchaseReturn"
    );

    setPurchaseTaxData([
      ...formattedPurchase,
      ...formattedPurchaseReturn,
    ]);

  } catch (error) {
    console.log("Tax Report Error:", error);
  }
};




useEffect(() => {
  if (!clientData?.id) return;

  if (fromDate && toDate && fromDate > toDate) {
    return;
  }

  loadTaxReport();
}, [fromDate, toDate, clientData?.id]);
  

const exportToPDF = () => {
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a4",
  });

  const currentData =
    reportType === "sale"
      ? saleTaxData
      : purchaseTaxData;

  const reportTitle =
    reportType === "sale"
      ? "GST Report - (SALES)"
      : "GST Report - (PURCHASES)";

  // Title
  doc.setFontSize(18);
  doc.setFont("helvetica", "bold");
  doc.text(reportTitle, 148, 15, {
    align: "center",
  });

  // Generated date
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");

  doc.text(
    `From Date : ${fromDate || "All"}`,
    14,
    25
  );

  doc.text(
    `To Date : ${toDate || "All"}`,
    14,
    32
  );

  doc.text(
    `Generated On : ${new Date().toLocaleString()}`,
    14,
    39
  );

  autoTable(doc, {
    startY: 46,

    head: [[
      "Date Time",
      "Particulars",
      "Party GSTIN",
      "Vch Type",
      "Vch No",
      "Taxable Amount",
      "IGST",
      "CGST",
      "SGST",
      "Cess",
      "Tax Amount",
      "Bill Amount",
    ]],

    body: currentData.map((item) => [
      item.dateTime || "-",
      item.particulars || "-",
      item.partyGstin || "-",
      item.vchType || "-",
      item.vchNo ?? "-",
      Number(item.taxableAmount || 0).toFixed(2),
      Number(item.igst || 0).toFixed(2),
      Number(item.cgst || 0).toFixed(2),
      Number(item.sgst || 0).toFixed(2),
      Number(item.cess || 0).toFixed(2),
      Number(item.taxAmount || 0).toFixed(2),
      Number(item.billAmount || 0).toFixed(2),
    ]),

    theme: "grid",

    styles: {
      fontSize: 7,
      cellPadding: 2,
      valign: "middle",
    },

    headStyles: {
      fillColor: [100, 100, 100],
      textColor: [255, 255, 255],
      fontStyle: "bold",
      fontSize: 7,
    },

    columnStyles: {
      0: { cellWidth: 25 },
      1: { cellWidth: 30 },
      2: { cellWidth: 30 },
      3: { cellWidth: 24 },
      4: { cellWidth: 18 },
      5: { cellWidth: 24 },
      6: { cellWidth: 18 },
      7: { cellWidth: 18 },
      8: { cellWidth: 18 },
      9: { cellWidth: 15 },
      10: { cellWidth: 22 },
      11: { cellWidth: 24 },
    },
  });

  const finalY =
    doc.lastAutoTable?.finalY || 46;

  // Summary
  const totalTaxable = currentData.reduce(
    (sum, item) =>
      sum + Number(item.taxableAmount || 0),
    0
  );

  const totalIGST = currentData.reduce(
    (sum, item) =>
      sum + Number(item.igst || 0),
    0
  );

  const totalCGST = currentData.reduce(
    (sum, item) =>
      sum + Number(item.cgst || 0),
    0
  );

  const totalSGST = currentData.reduce(
    (sum, item) =>
      sum + Number(item.sgst || 0),
    0
  );

  const totalCess = currentData.reduce(
    (sum, item) =>
      sum + Number(item.cess || 0),
    0
  );

  const totalTax = currentData.reduce(
    (sum, item) =>
      sum + Number(item.taxAmount || 0),
    0
  );

  const totalBill = currentData.reduce(
    (sum, item) =>
      sum + Number(item.billAmount || 0),
    0
  );

  let summaryY = finalY + 10;

  doc.setFontSize(9);
  doc.setFont("helvetica", "bold");

  doc.text(
    `Total Entries : ${currentData.length}`,
    14,
    summaryY
  );

  doc.text(
    `Taxable Amount : Rs. ${totalTaxable.toFixed(2)}`,
    14,
    summaryY + 7
  );

  doc.text(
    `IGST : Rs. ${totalIGST.toFixed(2)}`,
    80,
    summaryY + 7
  );

  doc.text(
    `CGST : Rs. ${totalCGST.toFixed(2)}`,
    125,
    summaryY + 7
  );

  doc.text(
    `SGST : Rs. ${totalSGST.toFixed(2)}`,
    170,
    summaryY + 7
  );

  doc.text(
    `Cess : Rs. ${totalCess.toFixed(2)}`,
    215,
    summaryY + 7
  );

  doc.text(
    `Total Tax : Rs. ${totalTax.toFixed(2)}`,
    14,
    summaryY + 15
  );

  doc.text(
    `Bill Amount : Rs. ${totalBill.toFixed(2)}`,
    80,
    summaryY + 15
  );

  doc.save(
    `${reportType === "sale" ? "Sale" : "Purchase"}_GSTR_Report_${Date.now()}.pdf`
  );
};


const exportToExcel = async () => {
  const workbook = new ExcelJS.Workbook();

  const sheetName =
    reportType === "sale"
      ? "Sale GSTR"
      : "Purchase GSTR";

  const reportTitle =
    reportType === "sale"
      ? "GST Report - (SALES)"
      : "GST Report - (PURCHASES)";

  const currentData =
    reportType === "sale"
      ? saleTaxData
      : purchaseTaxData;

  const worksheet =
    workbook.addWorksheet(sheetName);

  // Title
  worksheet.addRow([reportTitle]);

  worksheet.mergeCells("A1:L1");

  const title = worksheet.getCell("A1");

  title.font = {
    bold: true,
    size: 18,
    color: { argb: "FFFFFF" },
  };

  title.fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "1F4E78" },
  };

  title.alignment = {
    horizontal: "center",
    vertical: "middle",
  };

  worksheet.getRow(1).height = 30;

  // Date information
  worksheet.addRow([]);

  worksheet.addRow([
    "From Date",
    fromDate || "All",
  ]);

  worksheet.addRow([
    "To Date",
    toDate || "All",
  ]);

  worksheet.addRow([
    "Generated On",
    new Date().toLocaleString(),
  ]);

  worksheet.addRow([]);

  // Header
  worksheet.addRow([
    "Date Time",
    "Particulars",
    "Party GSTIN",
    "Vch Type",
    "Vch No",
    "Taxable Amount",
    "IGST",
    "CGST",
    "SGST",
    "Cess",
    "Tax Amount",
    "Bill Amount",
  ]);

  const header = worksheet.getRow(7);

  header.font = {
    bold: true,
    color: { argb: "FFFFFF" },
  };

  header.fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "4472C4" },
  };

  header.alignment = {
    horizontal: "center",
    vertical: "middle",
  };

  // Data
  currentData.forEach((item) => {
    worksheet.addRow([
      item.dateTime || "-",
      item.particulars || "-",
      item.partyGstin || "-",
      item.vchType || "-",
      item.vchNo ?? "-",
      Number(item.taxableAmount || 0).toFixed(2),
      Number(item.igst || 0).toFixed(2),
      Number(item.cgst || 0).toFixed(2),
      Number(item.sgst || 0).toFixed(2),
      Number(item.cess || 0).toFixed(2),
      Number(item.taxAmount || 0).toFixed(2),
      Number(item.billAmount || 0).toFixed(2),
    ]);
  });

  // Totals
  const totalTaxable = currentData.reduce(
    (sum, item) =>
      sum + Number(item.taxableAmount || 0),
    0
  );

  const totalIGST = currentData.reduce(
    (sum, item) =>
      sum + Number(item.igst || 0),
    0
  );

  const totalCGST = currentData.reduce(
    (sum, item) =>
      sum + Number(item.cgst || 0),
    0
  );

  const totalSGST = currentData.reduce(
    (sum, item) =>
      sum + Number(item.sgst || 0),
    0
  );

  const totalCess = currentData.reduce(
    (sum, item) =>
      sum + Number(item.cess || 0),
    0
  );

  const totalTax = currentData.reduce(
    (sum, item) =>
      sum + Number(item.taxAmount || 0),
    0
  );

  const totalBill = currentData.reduce(
    (sum, item) =>
      sum + Number(item.billAmount || 0),
    0
  );

  worksheet.addRow([]);

  const totalRow = worksheet.addRow([
    "TOTAL",
    "",
    "",
    "",
    "",
    totalTaxable.toFixed(2),
    totalIGST.toFixed(2),
    totalCGST.toFixed(2),
    totalSGST.toFixed(2),
    totalCess.toFixed(2),
    totalTax.toFixed(2),
    totalBill.toFixed(2),
  ]);

  totalRow.font = {
    bold: true,
  };

  totalRow.fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "D9EAF7" },
  };

  // Column widths
  worksheet.columns = [
    { width: 23 }, // Date
    { width: 25 }, // Particulars
    { width: 25 }, // GSTIN
    { width: 18 }, // Vch Type
    { width: 14 }, // Vch No
    { width: 20 }, // Taxable
    { width: 15 }, // IGST
    { width: 15 }, // CGST
    { width: 15 }, // SGST
    { width: 15 }, // Cess
    { width: 18 }, // Tax
    { width: 20 }, // Bill
  ];

  // Borders
  worksheet.eachRow((row) => {
    row.eachCell((cell) => {
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };

      cell.alignment = {
        vertical: "middle",
      };
    });
  });

  // Freeze header
  worksheet.views = [
    {
      state: "frozen",
      ySplit: 7,
    },
  ];

  const buffer =
    await workbook.xlsx.writeBuffer();

  saveAs(
    new Blob([buffer]),
    `${reportType === "sale" ? "Sale" : "Purchase"}_GSTR_Report_${Date.now()}.xlsx`
  );
};

  return (
    <div
      className="container-fluid p-0"
      style={{
        background: "#c7d4e4",
        minHeight: "100vh",
      }}
    >

      {/* DATE FILTER */}
      <div className="row mb-3">

        <div className="col-6 col-md-6">
          <label className="form-label fw-bold">
            From Date
          </label>

          <input
            type="date"
            className="form-control w-100"
            style={{ maxWidth: "220px" }}
            value={fromDate}
            onChange={(e) => {
              setFromDate(e.target.value);

              if (toDate && e.target.value > toDate) {
                setToDate("");
              }
            }}
          />
        </div>

        <div className="col-6 col-md-6 d-flex flex-column align-items-md-end">
          <label className="form-label fw-bold">
            To Date
          </label>

          <input
            type="date"
            className="form-control w-100"
            style={{ maxWidth: "220px" }}
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
        </div>

      </div>


      {/* TAX TABLE */}
      <div className="table-responsive">
        <table
          className="table table-bordered text-center mb-0"
          style={{
            background: "#fff",
          }}
        >

          <thead>
            <tr
              style={{
                background:
                  reportType === "sale"
                    ? "#f9a602"
                    : "#ffc107",
                color: "#fff",
              }}
            >
              <th>Date Time</th>
              <th>Particulars</th>
              <th>Party GSTIN</th>
              <th>Vch Type</th>
              <th>Vch No</th>
              <th>Taxable Amount</th>
              <th>IGST</th>
              <th>CGST</th>
              <th>SGST</th>
              <th>Cess</th>
              <th>Tax Amount</th>
              <th>Bill Amount</th>
            </tr>
          </thead>


       <tbody>
  {(reportType === "sale"
    ? saleTaxData
    : purchaseTaxData
  ).map((item, index) => (
    <tr key={`${item.id}-${index}`}>

      <td>{item.dateTime}</td>

      <td>{item.particulars}</td>

      <td>{item.partyGstin}</td>

      <td>{item.vchType}</td>

      <td>{item.vchNo}</td>

      <td>{item.taxableAmount.toFixed(2)}</td>

      <td>{item.igst.toFixed(2)}</td>

      <td>{item.cgst.toFixed(2)}</td>

      <td>{item.sgst.toFixed(2)}</td>

      <td>{item.cess.toFixed(2)}</td>

      <td>{item.taxAmount.toFixed(2)}</td>

      <td>{item.billAmount.toFixed(2)}</td>

    </tr>
  ))}

  {(reportType === "sale"
    ? saleTaxData
    : purchaseTaxData
  ).length === 0 && (
    <tr>
      <td colSpan="12">
        No {reportType === "sale" ? "Sale" : "Purchase"} data found
      </td>
    </tr>
  )}
</tbody>

        </table>
      </div>


      {/* REPORT TYPE BUTTONS */}
  <div className="d-flex justify-content-between align-items-center mt-3 mb-1 flex-wrap gap-3">

  {/* LEFT SIDE - REPORT TYPE */}
  <div className="d-flex align-items-center gap-2">

    <button
      type="button"
      onClick={() => setReportType("sale")}
      className={`btn ${
        reportType === "sale"
          ? "btn-success"
          : "btn-outline-success"
      }`}
    >
      Sale GSTR
    </button>

    <button
      type="button"
      onClick={() => setReportType("purchase")}
      className={`btn ${
        reportType === "purchase"
          ? "btn-warning"
          : "btn-outline-warning"
      }`}
    >
      Purchase GSTR
    </button>

  </div>


  {/* RIGHT SIDE - EXPORT BUTTONS */}
  <div className="d-flex align-items-center gap-2">

    {/* EXCEL */}
    <button
      type="button"
      className="btn d-flex align-items-center gap-2 px-4 py-2 shadow"
      onClick={exportToExcel}
      style={{
        background:
          "linear-gradient(135deg, #28a745, #198754)",
        color: "#fff",
        border: "none",
        borderRadius: "10px",
        fontWeight: "600",
        transition: "0.3s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform =
          "translateY(-2px)";
        e.currentTarget.style.boxShadow =
          "0 8px 20px rgba(25,135,84,0.35)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform =
          "translateY(0)";
        e.currentTarget.style.boxShadow = "";
      }}
    >
      <FaFileExcel size={20} />
      Excel
    </button>


    {/* PDF */}
    <button
      type="button"
      className="btn d-flex align-items-center gap-2 px-4 py-2 shadow"
      onClick={exportToPDF}
      style={{
        background:
          "linear-gradient(135deg, #dc3545, #b02a37)",
        color: "#fff",
        border: "none",
        borderRadius: "10px",
        fontWeight: "600",
        transition: "0.3s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform =
          "translateY(-2px)";
        e.currentTarget.style.boxShadow =
          "0 8px 20px rgba(220,53,69,0.35)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform =
          "translateY(0)";
        e.currentTarget.style.boxShadow = "";
      }}
    >
      <FaFilePdf size={20} />
      PDF
    </button>

  </div>

</div>

    </div>
  );
};

export default TaxReport;